<template>
    <Head>
        <title>Профиль</title>
    </Head>

    <AuthenticatedLayout :notifications="notifications">
        <template #header>
            <NavigationSettings />
        </template>

        <div class="py-8 max-w-7xl mx-auto grid gap-4 grid-cols-1 sm:grid-cols-2 items-start">
            <FormChangePassword/>

            <div v-if="tg" class="p-6 bg-white border border-gray-200 sm:rounded-lg">
                <h3 class="text-center font-semibold text-xl text-gray-800 sm:leading-tight pb-4">
                    Интеграция с Telegram
                </h3>
                <div v-if="tg.status  === 'create'" class="flex flex-col gap-4 items-center">
                    <a :href="tg.createLink" class="underline text-blue-700">
                        <qrcode-vue :value="tg.createLink" size="300" level="H" />
                    </a>
                    <p>
                        Или отправьте боту
                        <a class="text-blue-700" :href="`tg://resolve?domain=${tg.bot}`">
                            @{{ tg.bot }}
                        </a>
                        команду
                        <a :href="tg.createLink" class="text-blue-700">
                            <code>/start</code>
                        </a>
                    </p>
                    <form method="post" action="/" class="flex flex-row gap-4 items-end" @submit.prevent="setTgId">
                        <v-input label="Telegram ID" v-model="newTgId" title="Введите от 7 до 10 цифр" pattern="\d{7,10}" maxlength="10" required/>
                        <v-button :disabled="!newTgId">Подключить</v-button>
                    </form>
                </div>
                <div v-if="tg.status  === 'confirmed'" class="flex flex-col gap-4 items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 fill-current text-green-500" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                    </svg>
                    <p>Подключен аккаунт
                        <a class="text-blue-700" :href="`tg://resolve?domain=${tg.username}`">
                            @{{ tg.username }}
                        </a>
                    </p>
                </div>
                <div v-if="tg.status  === 'fail'" class="flex flex-col gap-4 items-center text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 fill-current text-red-500" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                    </svg>
                    <p class="text-red-500">Нет информации о пользователе</p>
                    <p>Узнать <strong>Telegram ID</strong> можно у бота
                        <a class="text-blue-700" :href="`tg://resolve?domain=${tg.bot}`">
                            @{{ tg.bot }}
                        </a>
                        <br>отправив ему команду <code>/start</code>
                    </p>
                    <p class="text-gray-700">Ваш <strong>Telegram ID</strong>: <code>{{ tg.id }}</code></p>
                </div>
            </div>
        </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated.vue';
import NavigationSettings from '@/Components/Navigation/Settings';
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import FormChangePassword from '@/Components/Forms/ChangePassword';
import TwoFactorAuthentication from '@/Components/Forms/2FA';
import NavLink from '@/Components/NavLink.vue';
import VButton from '@/Components/Button';
import VInput from '@/Components/Input';
import QrcodeVue from 'qrcode.vue';


export default {
    components: {
        Head, Link,
        NavigationSettings,
        AuthenticatedLayout,
        FormChangePassword,
        TwoFactorAuthentication,
        NavLink,
        VButton,
        VInput,
        QrcodeVue,
    },
    data() {
        return {
            newTgId: '',
        }
    },
    props: {
        notifications: Array,
        tg: Object,
    },
    methods: {
        setTgId() {
            useForm({tgId: this.newTgId}).post(this.route('settings.set-tg-id'));
        },
    }
}
</script>
